import _ from 'lodash';
import React, { useEffect, useState, useRef } from 'react'
import './index.css'

const ChatbotDemo = (props) => {

    const [items, setItems] = useState([]);
    const [script, setScript] = useState(props.script);
    let chatDelay = 0;
    const prevPropItems = useRef();

    const constructElements = () => {
        let itemArray = []

        script.forEach((obj, idx) => {
            itemArray.push(
                <div key={idx} className={`message-container message-${obj.align} ${obj.name} pull-${obj.align}`} hidden>
                    <div className={`message-text-wrapper messageinner-${obj.name}`} hidden>
                        <span className="message-text">{obj.msg}</span>
                    </div> 
                </div>
            )
            if(idx==script.length-1){
              itemArray.push(
                <div key={`${idx}-2`} className={`message-container last`}>
                     <div className={`message-text-wrapper messageinner`}>
                        <span className="message-text">&nbsp;</span>
                    </div> 
                </div>
            )
            }
        })
        setItems(itemArray);
       
    }

    const onRowAdded = () => {
        const chatContainer = document.querySelector('.innerScreen')
        if(chatContainer) {
            chatContainer.scroll({
                top: chatContainer.scrollHeight,
                behavior: 'smooth'
            })
        }
    }
    const removeAllChildNodes = (parent)=> {
      while (parent.firstChild) {
          parent.removeChild(parent.firstChild);
      }
      setItems([])
    }

    const fakeLoad = ()=>{
      const bubbles = document.querySelectorAll('.chat-message-list')
      removeAllChildNodes(bubbles)

      const messageContainer = document.querySelector(`.bot-preview-chat-container`)
      const loaderContainer = document.querySelector(`.phone-loader-container`)

      messageContainer.classList.add('hidden')
      loaderContainer.classList.remove('hidden')
     
      setTimeout((
      )=>{
        loaderContainer.classList.add('hidden')
        messageContainer.classList.remove('hidden')
      },1500)
    }

    const renderMessages = () => {
        setTimeout(()=>{
          script.forEach(obj => {
            chatDelay = chatDelay + 1500;

            let msgname = document.querySelector(`.${obj.name}`);
            let msginner = document.querySelector(`.messageinner-${obj.name}`);
            
            setTimeout(() => {
                if(msgname) msgname.removeAttribute("hidden");
            }, chatDelay)

            setTimeout(() => {
                if(msginner) msginner.removeAttribute("hidden");
            }, chatDelay)

            setTimeout(onRowAdded, chatDelay);
        })
        },1000)
       
    }

    // Construct all elements in DOM
    useEffect(() => {

        if(! _.isEqual(prevPropItems.current,props.script)){
          setScript(props.script)
          fakeLoad()
        }
        prevPropItems.current = props.script
       
    }, [props.script])

    useEffect(()=>{
      constructElements();
    },[script])

    useEffect(()=>{
      renderMessages()
    },[items])

    return (
      <div style={{ position: 'absolute' }}>
        <div class="iphone-x">
          <div class="bazzel">
            <div class="screen"></div>
          </div>
          <div class="line"></div>
          <div class="header">
            <div class="sensor-1"></div>
            <div class="sensor-2"></div>
            <div class="sensor-3"></div>
          </div>
          <div class="volume-button"></div>
          <div class="power-button"></div>
        </div>

        <div class="innerScreen">
          <div class="phone-loader-container">
             <div class="phone-loader"></div>
          </div>
          <div className="bot-preview-chat-container">
            <div className="chat-listcontainer">
              <div className="chat-message-list">
                {items.length ? items : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default ChatbotDemo;